import React, { useEffect, useState } from "react";
import {
  ChakraProvider,
  Box,
  Heading,
  Text,
  Container,
  Button,
  useToast,
  HStack,
  Link,
} from "@chakra-ui/react";
import StatPanel from "./components/StatPanel";
import TradingViewWidget from "./components/TradingViewWidget";
import TipButton from "./components/TipButton";
import Footer from "./components/Footer";
import { loginWithPi } from "./utils/piSdk";
import { initializePiSdk } from "./PiService";

function App() {
  const [username, setUsername] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const toast = useToast();

  useEffect(() => {
    initializePiSdk();
  }, []);

  const handleLogin = async () => {
    const result = await loginWithPi();
    console.log("📥 Pi Login Result:", result);

    if (result) {
      setUsername(result.user.username);
      setAccessToken(result.accessToken);

      const verifyRes = await fetch("https://pi-chart-backend.onrender.com/verify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ accessToken: result.accessToken }),
      });

      if (verifyRes.ok) {
        toast({
          title: "Logged in!",
          description: `Welcome ${result.user.username}`,
          status: "success",
          duration: 3000,
        });
      } else {
        toast({
          title: "Verification failed",
          status: "error",
          duration: 3000,
        });
      }
    }
  };

  return (
    <ChakraProvider>
      <Box bg="gray.900" minH="100vh" color="white" py={10}>
        <Container maxW="container.xl" textAlign="center">
          <Heading as="h1" size="xl" mb={2}>
            📈 PiChart – Live Pi/USDT Market Dashboard
          </Heading>
          <Text fontSize="md" color="gray.400" mb={4}>
            Real-time price data from MEXC and interactive TradingView chart
          </Text>

          <Button onClick={handleLogin} colorScheme="yellow" size="sm" mb={6}>
            {username ? `Logged in as ${username}` : "Login with Pi"}
          </Button>

          <StatPanel />

          <Box mt={10}>
            <TradingViewWidget />
          </Box>

          {/* 📘 Add the new buttons here */}
          <HStack spacing={4} mt={6} justify="center">
            <Link href="https://www.babypips.com/learn" isExternal>
              <Button colorScheme="blue" variant="outline">
                📘 Trading Education
              </Button>
            </Link>
            <Link href="https://cointelegraph.com/" isExternal>
              <Button colorScheme="purple" variant="outline">
                📰 Crypto News
              </Button>
            </Link>
          </HStack>

          <TipButton accessToken={accessToken} />
        </Container>
        <Footer />
      </Box>
    </ChakraProvider>
  );
}

export default App;
